import React from 'react'

import { Card, CardBody } from '@omnilert/components'

import Skeleton from '@material-ui/lab/Skeleton'
import Typography from '@material-ui/core/Typography'

import useStyles from './reference-loader.style'

/*
 * DEV-5188: kept compact (~120px) so a row waiting on a Firestore reference
 * doc resolves without dominating the scroll area. The previous layout was
 * ~800px of skeleton (rect + carousel) which produced ghost tall rows at
 * the top of the Messages history whenever the document hadn't loaded yet.
 */
const ReferenceLoader = props => {
  const classes = useStyles(props)

  return (
    <Card className={classes.card}>
      <CardBody className={classes.cardBody}>
        <Typography variant='h4'>
          <Skeleton />
        </Typography>
        <Typography variant='h4'>
          <Skeleton />
        </Typography>
        <Skeleton variant='text' />
      </CardBody>
    </Card>
  )
}

export default ReferenceLoader
